/* eslint-disable no-unused-expressions */
/**
 * Created by Tiger on 21/02/2022.
 */
import React, {useEffect, useMemo, useState} from 'react';
import Styles from './css/ConfigManager.module.scss';
import ConfigHeader from './config-header';
import {Dropdown, Table} from 'antd';
import actions from '../../redux/action';
import {connect} from 'react-redux';
import NewConfig from './new-config';
import i18n from 'i18next';
import tableMenu from '../../components/menu';
import {MoreOutlined} from '../../components/lib';
import EditConfigTipModal from './edit-config-tip-modal';

function ConfigManager(props) {
    const [currentConfig, setCurrentConfig] = useState(null);
    const [scrollY, setScrollY] = useState(document.body.clientHeight - 200);
    const [editConfigTipVisible, setEditConfigTipVisible] = useState(false);
    const [editedConfigName, setEditedConfigName] = useState('');
    const configTableColumns = useMemo(() => {
        return [{ title: i18n.t('config_name'), dataIndex: 'name', key: 'name' }, {
            title: i18n.t('net_type'), dataIndex: 'type', key: 'type',
        }, { title: i18n.t('encrypt_type'), dataIndex: 'encryptType', key: 'encryptType' }, {
            title: i18n.t('report_interval'), dataIndex: 'reportInterval', key: 'reportInterval',
        }, { title: i18n.t('collect_interval'), dataIndex: 'collectInterval', key: 'collectInterval' }, {
            title: i18n.t('device_count'), dataIndex: 'deviceCnt', key: 'deviceCnt',
            render: (text, record) => (
                <a
                    onClick={(e) => {
                        e.stopPropagation();
                        props.history.push({
                            pathname: '/private/device-binding',
                            state: {
                                privateConfigId: record.originalData?.id,
                                activeTab: 'sent'
                            }
                        });
                    }}
                    style={{ color: '#1890ff', cursor: 'pointer' }}
                >
                    {text}
                </a>
            )
        }, {
            title: i18n.t('operations'),
            render: (record) =><Dropdown
            arrow={true}
            placement={'bottom'}
            trigger={['hover']}
            overlay={tableMenu.bind(this, {
                onEdit: (e) => {
                    e?.domEvent?.stopPropagation();
                    setCurrentConfig(record.originalData);
                    setEditedConfigName(record.originalData?.name || '');
                    setNewConfigDialogVisible(true);
                },
                onDelete: (e) => {
                    e?.domEvent?.stopPropagation();
                    props.onDeleteConfig(record);
                    console.log('delete onclick');
                },
            })}
        >
            <div
                style={{ width: 50 }}
                onClick={(e) => e.stopPropagation()}
            >
                <MoreOutlined />
            </div>
        </Dropdown>,
            key: 'operate',
        }];
    }, [props.language]);
    useEffect(() => {
        props.onRefreshConfigList();
    }, [props.language]);
    useEffect(() => {
        const h = document.getElementById('tableContainer').offsetHeight - 100;
        setScrollY(h);
    }, []);

    const [newConfigDialogVisible, setNewConfigDialogVisible] = useState(false);
    return <div className={ Styles.container }>
        <ConfigHeader addConfig={ () => {
            setCurrentConfig(null);
            setNewConfigDialogVisible(true);
        } }/>
        <div id={ 'tableContainer' } className={ Styles.tableContainer }>
            <Table rowKey={ ({ id }) => `${ id }}` } 
                   style={ { marginTop: 10 } } 
                   columns={ configTableColumns }
                   dataSource={ props.tableDataSource }
                   size={ 'small' }
                   scroll={ { y: scrollY } }
                   pagination={ false }
                   loading={ props.tableLoading }
                   />
        </div>
        { newConfigDialogVisible && <NewConfig
            config={ currentConfig }
            visible={ newConfigDialogVisible }
            onOk={ () => {
                // 仅编辑模显示提示弹窗
                if (currentConfig) {
                    setEditConfigTipVisible(true);
                }
                setCurrentConfig(null);
                setNewConfigDialogVisible(false);
            } }
            onCancel={ () => {
                setCurrentConfig(null);
                setNewConfigDialogVisible(false);
            } }
        /> }
        <EditConfigTipModal
            visible={editConfigTipVisible}
            onOk={() => {
                setEditConfigTipVisible(false);
                setEditedConfigName('');
            }}
            configName={editedConfigName}
        />

    </div>;
}

const mapStateToProp = state => {
    return {
        tableLoading: state.config.tableLoading,
        tableDataSource: state.config.configList,
        tableColumn: state.config.tableColumn,
        language: state.language.language,
    };
};

const mapDispatchToProp = dispatch => ({
    onRefreshConfigList: () => dispatch(actions.onRefreshConfigList()),
    onDeleteConfig: config => dispatch(actions.onDeleteConfig(config)),
});

export default connect(mapStateToProp, mapDispatchToProp)(ConfigManager);
